import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { doItemAction } from '#utils/PRIVATE_legendUtils/testAdapterUtil';

export class SectionalLegendAdapter extends TestAdapter {
  async doItemAction(id: number | string): Promise<void> {
    await doItemAction(id, await this.getElement());
  }
}
